import { Controller } from "stimulus"

export default class extends Controller {
    initialize() {
        setTimeout(() => {
            document.getElementById("cart-form").submit();
        }, 2000);
    }
}
